module.exports = __webpack_public_path__ + "static/media/Facebook.69195917.svg";